<template>
  <main>
    <div class="gp-main-body-content">
      <Modal :hideExit="true" cClass="mw424">
        <template #header>
          <p class="typo-heading20 typo-medium text-light-high">Agency Login</p>
        </template>
        <template #default>
          <form ref="form" @submit.prevent="agencyLogin">
            <div class="form-group">
              <label class="label typo-button14 typo-medium text-light-high">{{ $t("generals.email") }}</label>
              <input class="input-field input-field-block" :class="{ 'is-error': alertText && alertText.length }" type="email" required v-focus :title="$t('generals.email')" placeholder="chris@gempages.help" v-model="username" />
              <!-- <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p> -->
            </div>
            <div class="form-group">
              <label class="label typo-button14 typo-medium text-light-high">{{ $t("generals.password") }}</label>
              <input class="input-field input-field-block" :class="{ 'is-error': alertText && alertText.length }" type="password" required :title="$t('generals.password')" :placeholder="$t('generals.password')" v-model="password" />
            </div>
            <div class="d-flex mt-1 justify-content-end">
              <router-link :to="{ name: 'AgencyForgot' }" class="text-mono3">Forgot password?</router-link>
            </div>
            <p class="typo-paragraph12 typo-italic text-danger mt-half mnh-16">{{ alertText }}</p>
            <div class="btn-group flex-row-reverse make-default-btn mt-2">
              <ProcessButton class="btn btn-primary btn-block btn-default" type="submit" :status.sync="btnStatus">
                <template #loading>Loging in ...</template>
                <template #success>{{ $t("generals.success") }}</template>
                <template #error>Failed</template>
                <template #default>Login</template>
              </ProcessButton>
            </div>
          </form>
        </template>
      </Modal>
    </div>

    <PortalTarget name="modals" multiple></PortalTarget>
  </main>
</template>

<script>
import { Api, ApiUrl } from "@/services";
import ProcessButton from "@/core/shared/ProcessButton.vue";

export default {
  name: "AgencyLogin",
  components: {
    ProcessButton
  },
  data() {
    return {
      username: "",
      password: "",
      btnStatus: {
        success: false,
        loading: false,
        error: false
      },
      alertText: ""
    };
  },
  computed: {},

  created() {},
  mounted() {},
  methods: {
    agencyLogin() {
      this.alertText = "";
      this.btnStatus.loading = true;

      // if (true) {

      // }

      let data = {
        email: this.username,
        password: this.password
      };
      const wrongUoP = this.$t("agency.wrongUoP");
      Api.base
        .post(ApiUrl.base.agency.login, data)
        .then((res) => {
          if (res.data.status === 'success') {
            this.btnStatus.success = true;
            window.location.href = "/agency"
            this.timeout = setTimeout(() => {
              this.btnStatus.success = false;
            }, 1500);
          } else {
            this.btnStatus.error = true;
            this.alertText = wrongUoP;
            this.timeout = setTimeout(() => {
              this.btnStatus.error = false;
            }, 1500);
          }
        })
        .catch(() => {
          this.btnStatus.error = true;
          this.alertText = wrongUoP;
          this.timeout = setTimeout(() => {
            this.btnStatus.error = false;
          }, 1500);
        })
        .finally(() => {
          this.btnStatus.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.mnh-16 {
  min-height: 16px;
}
</style>
